import { Car, DollarSign, TrendingUp, Users } from 'lucide-react'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'

interface dashboardCardProps {
  summary: {
    totalDrivers: number
    onlineDrivers: number
    offlineDrivers: number
    averageRating: number
    onlinePercentage: number
    totalRides: number
    totalEarnings: string
    subscription: number
  }
}

export default function DashboardCard({ summary }: dashboardCardProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">
            Comissão de Corridas
          </CardTitle>
          <DollarSign className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold text-green-600">
            {summary.totalEarnings}
          </div>
          <p className="text-xs text-muted-foreground">
            {/* <span className="text-green-600">+{summary.commissionGrowth}%</span>{' '}
            {periodLabel}*/}
          </p>
        </CardContent>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">
            Comissão de Assinaturas
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">Em breve</div>
          <p className="text-xs text-muted-foreground">
            {/*<span className="text-green-600">+{summary.commissionGrowth}%</span>{' '}
            {periodLabel}*/}
          </p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">
            Motoristas Online
          </CardTitle>
          <Users className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">
            {summary.onlineDrivers}/{summary.totalDrivers}
          </div>
          <p className="text-xs text-muted-foreground">
            {summary.onlinePercentage}% da frota online
          </p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Corridas Totais</CardTitle>
          <Car className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{summary.totalRides}</div>
          <p className="text-xs text-muted-foreground">
            Média de {Math.round(summary.totalRides / summary.totalDrivers)} por
            motorista
          </p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Assinaturas</CardTitle>
          <TrendingUp className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{summary.subscription}</div>
        </CardContent>
      </Card>
    </div>
  )
}
